import styles from "./button.module.scss";

type Props = {
  label: string | React.ReactNode;
  type?: "primary" | "secondary" | "success" | "error";
  img?: any;
  className?: any;
  active?: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  imgClassName?: string;
  style?: React.CSSProperties; // Add style prop
};

const Button = ({
  label,
  img,
  imgClassName = "",
  type = "primary",
  className,
  active,
  disabled,
  onClick,
  style, // Add style to destructured props
  ...props
}: Props) => {
  return (
    <button
      className={`${styles.button} ${styles[type]} ${active ? styles.active : ""} ${disabled ? styles.disabled : ""} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={style} // Add style to the button element
      {...props}
    >
      {img && <img src={img} className={imgClassName} />}
      {label}
    </button>
  );
};

export default Button;
